import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Cell } from 'src/types/Repository';

interface RepositoryState {
  currentRowId: number | null;
  currentCellParams: Cell | null;
}

const initialState: RepositoryState = {
  currentRowId: null,
  currentCellParams: null
};

const slice = createSlice({
  name: 'repository',
  initialState,
  reducers: {
    setCurrentRow(
      state: RepositoryState,
      action: PayloadAction<number>
    ) {
      state.currentRowId = action.payload;
    },
    resetCurrentRow(
      state: RepositoryState
    ) {
      state.currentRowId = null;
    },
    setCurrentCell(
      state: RepositoryState,
      action: PayloadAction<Cell>
    ) {
      state.currentCellParams = action.payload;
    },
    resetCurrentCell(
      state: RepositoryState
    ) {
      state.currentCellParams = null;
    }
  }
});

export const { reducer } = slice;

export const {
  setCurrentRow,
  resetCurrentRow,
  setCurrentCell,
  resetCurrentCell
} = slice.actions;

export default slice;
